/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20088Req {
  
  /** 手机号 */
  telephone?: string;
  /** 密码 */
  passWd?: string;
  /** 验证码 */
  mtCode?: string;
};



export interface API20088Res {
  /**   */
  code?: number;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  
};


// 20088 密码重置接口

export interface IUsePostAPI20088Return {
  /** 密码重置接口: 接口请求状态 */
  isAPI20088Loading: boolean;
  /** 密码重置接口: 接口请求返回数据 */
  dataAPI20088: API20088Res;
  /**  密码重置接口: 接口数据请求方法 */
  fetchAPI20088Data:  (inputs: API20088Req, config?: YWRequestConfig) => Promise<API20088Res>;
  /** 密码重置接口: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20088 = ():IUsePostAPI20088Return => {
  let isMount = true;
  const [isAPI20088Loading, setIsAPI20088Loading] = useState(false);
  const [dataAPI20088, setDataAPI20088] = useState<API20088Res>({} as API20088Res);
  const requestUrl = `${basePath}/ywwl-admin/user/updatePassWdByMtCode`;

  const fetchAPI20088Data = async (inputs: API20088Req, config?: YWRequestConfig): Promise<API20088Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20088Req>) || {}) as API20088Req;
    
  
    if ( isMount ) {
      setIsAPI20088Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20088Res>(`${basePath}/ywwl-admin/user/updatePassWdByMtCode`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20088(res || {} as API20088Res);
        setIsAPI20088Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20088Loading(false);
      }
      return false as unknown as API20088Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20088Loading,
    dataAPI20088,
    fetchAPI20088Data,
    requestUrl,
  }
}

